import React from "react";
import Dispatcher from "../../dispatcher";
import BookUtils from "../../utils/book-utils";
import BookStore from "../../stores/book-store";
import FractionStore from "../../stores/fraction-store";
import BookmarkAction from "../../actions/bookmark-action";
import BookmarkStore from "../../stores/bookmark-store";
import MarkerStore from "../../stores/marker-store";
import HighlighterColors from "./highlights/highlighter-colors";
import ColorBar from "./highlights/color-bar";
import PageNumberForm from "./page-number-form";
import ToolbarWithTts from "./tts/toolbar-with-tts";
import Speaker from "./tts/speaker";
import ScrubberToolTip from "./ScrubberToolTip";
import { colors } from "chameleonjs";

var Scrubber = require("./scrubber");
var Tooltip = require("../ui_elements/tooltip").Tooltip;
var TooltipMixin = require("../ui_elements/tooltip").TooltipMixin;
var Menu = require("../ui_elements/menu").Menu;
var MenuMixin = require("../ui_elements/menu").MenuMixin;
var MenuList = require("../ui_elements/menu-list");
var MenuHeader = require("../ui_elements/menu-header");
var Isvg = require("../../../vendor/react-inlinesvg");
var ZoomButton = require("../ui_elements/zoom-button");
import EnhancedFormatting from "../ui_elements/enhanced-formatting";
import PrintRangeToggleMenu from "./printer/print-range-toggle-menu";
var BookmarksContainer = require("./bookmarks/bookmarks-container");
import _showMobileGoToPage from "../resources/mobile-go-to-page";

var CitationsMixin = require("../resources/citations").CitationsMixin;

/*
  Renders the scrubber container
    props:
    state:
*/
class ScrubberContainer extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showPage: false,
      pageNumber: "",
      scrubberBarHidden: this._getScrubberBarState(),
      bookmarks: null,
      ttsOn: false
    };

    this._isMounted = false;

    this.scrubberContainerRef = React.createRef();
    this.scrubberButtonsRef = React.createRef();
    this.bookmarkRef = React.createRef();

    // TooltipMixin bindings
    this.showTooltip = TooltipMixin.showTooltip.bind(this);
    this.removeTooltip = TooltipMixin.removeTooltip.bind(this);
    this._addTooltipEvent = TooltipMixin._addTooltipEvent.bind(this);
    this._removeTooltipEvent = TooltipMixin._removeTooltipEvent.bind(this);

    // MenuMixin bindings
    this._toggleMenu = MenuMixin._toggleMenu.bind(this);
    this._showMenu = MenuMixin._showMenu.bind(this);
    this._removeMenu = MenuMixin._removeMenu.bind(this);
    this._redrawMenu = MenuMixin._redrawMenu.bind(this);

    // Bind all methods that use `this`
    this._pageReady = this._pageReady.bind(this);
    this._fractionStoreChanged = this._fractionStoreChanged.bind(this);
    this._getScrubberBarState = this._getScrubberBarState.bind(this);
    this._scrubberBarHidden = this._scrubberBarHidden.bind(this);
    this._pageLoad = this._pageLoad.bind(this);
    this._pageBreak = this._pageBreak.bind(this);
    this._pageScroll = this._pageScroll.bind(this);
    this.setPageAndDefaultPage = this.setPageAndDefaultPage.bind(this);
    this._goToPageBlur = this._goToPageBlur.bind(this);
    this._goToPageChange = this._goToPageChange.bind(this);
    this._goToPageMobile = this._goToPageMobile.bind(this);
    this._showScrubberOptionMenu = this._showScrubberOptionMenu.bind(this);
    this._showBookmarkMenu = this._showBookmarkMenu.bind(this);
    this._bookmarksChanged = this._bookmarksChanged.bind(this);
    this._addBookmark = this._addBookmark.bind(this);
    this._bookmarkDeleteClicked = this._bookmarkDeleteClicked.bind(this);
    this._citeButtonEvent = this._citeButtonEvent.bind(this);
    this._ttsEvent = this._ttsEvent.bind(this);
    this._linkButtonEvent = this._linkButtonEvent.bind(this);
    this._addScrubberMenuTooltip = this._addScrubberMenuTooltip.bind(this);
    this._addScrubberViewTooltip = this._addScrubberViewTooltip.bind(this);
    this._scrubberMove = this._scrubberMove.bind(this);
    this._scrubberEnd = this._scrubberEnd.bind(this);
    this._goToPreviousPage = this._goToPreviousPage.bind(this);
    this._goToNextPage = this._goToNextPage.bind(this);
    this._takeSurvey = this._takeSurvey.bind(this);
    this.renderButtonTemplate = this.renderButtonTemplate.bind(this);
    this.turnTtsBarOn = this.turnTtsBarOn.bind(this);
    this.toggleTTS = this.toggleTTS.bind(this);
    this.renderSpeechIcon = this.renderSpeechIcon.bind(this);
    this._buildButtons = this._buildButtons.bind(this);
    this.renderBookMarkingButtons = this.renderBookMarkingButtons.bind(this);
    this._renderMobileScrubber = this._renderMobileScrubber.bind(this);
    this.renderTtsToolbar = this.renderTtsToolbar.bind(this);
  }

  componentDidMount() {
    this._isMounted = true;
    Dispatcher.setMaxListeners(Dispatcher.getMaxListeners() + 7);
    Dispatcher.bind(Dispatcher.BOOK_PAGEBREAK, this._pageBreak);
    Dispatcher.bind(Dispatcher.BOOK_PAGE_READY, this._pageReady);
    Dispatcher.bind(Dispatcher.BOOK_PAGE_LOAD, this._pageLoad);
    Dispatcher.bind(Dispatcher.BOOK_PAGE_SCROLL, this._pageScroll);
    Dispatcher.bind(Dispatcher.BOOKMARKS_CHANGE, this._bookmarksChanged);
    Dispatcher.bind(Dispatcher.BOOKMARKS_ACTION_FAILED, this._bookmarksChanged);
    Dispatcher.bind(Dispatcher.TTS_OPEN, this.turnTtsBarOn);
    Dispatcher.bind(
      Dispatcher.FRACTION_STORE_CHANGE,
      this._fractionStoreChanged
    );
    const book = BookStore.get(this.props.isbn);
    if (book.hasPageBreaks) {
      const pageNumber = BookUtils.getPageForCFI(this.props.isbn, book.pageCFI);
      this.setState({ showPage: true, pageNumber });
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
    Dispatcher.unbind(Dispatcher.BOOK_PAGEBREAK, this._pageBreak);
    Dispatcher.unbind(Dispatcher.BOOK_PAGE_READY, this._pageReady);
    Dispatcher.unbind(Dispatcher.BOOK_PAGE_LOAD, this._pageLoad);
    Dispatcher.unbind(Dispatcher.BOOK_PAGE_SCROLL, this._pageScroll);
    Dispatcher.unbind(Dispatcher.BOOKMARKS_CHANGE, this._bookmarksChanged);
    Dispatcher.unbind(Dispatcher.TTS_OPEN, this.turnTtsBarOn);
    Dispatcher.unbind(
      Dispatcher.BOOKMARKS_ACTION_FAILED,
      this._bookmarksChanged
    );
    Dispatcher.unbind(
      Dispatcher.FRACTION_STORE_CHANGE,
      this._fractionStoreChanged
    );
    clearTimeout(this.scrubberBarHiddenTimeout);
    clearTimeout(this.pageUpdateTimeout);
    clearTimeout(this.pageBreakTimeout);
    Dispatcher.setMaxListeners(Dispatcher.getMaxListeners() - 7);
  }

  _pageReady(isbn, e, data) {
    setTimeout(this.props.hideMobileMenuEvent, 550);
    if (!this.hideMobileMenu) {
      this.hideMobileMenu = true;
    } else {
      /*if (!this.keepMobileMenu){
        setTimeout(this.props.toggleMobileMenuEvent, 550);
      }
      this.keepMobileMenu = false;*/
    }

    this._pageLoad(isbn, e, data);
  }

  _fractionStoreChanged() {
    this.forceUpdate();
    this._scrubberBarHidden();
  }

  _getScrubberBarState() {
    return FractionStore.get()["scrubber-open"] ? "" : "none";
  }

  _scrubberBarHidden() {
    clearTimeout(this.scrubberBarHiddenTimeout);
    this.scrubberBarHiddenTimeout = setTimeout(() => {
      this.setState({ scrubberBarHidden: this._getScrubberBarState() });
    }, 333);
  }

  _pageLoad(isbn, e, data) {
    const book = BookStore.get(this.props.isbn);
    book.viewer.Book.hasNextPage(
      function(response) {
        if (this._isMounted) {
          this.setState({ hasNextPage: response.data });
        }
      }.bind(this)
    );
    book.viewer.Book.hasPreviousPage(
      function(response) {
        if (this._isMounted) {
          this.setState({ hasPrevPage: response.data });
        }
      }.bind(this)
    );
    var distanceThroughBook;
    if (data.page || this.state.showPage) {
      const book = BookStore.get(this.props.isbn);
      if (book.getPageBreaks()) {
        if (data.cfi) {
          distanceThroughBook = BookUtils.getDistanceThroughBook(
            this.props.isbn,
            book.pageCFI + "!" + data.cfi
          );
        } else if (data.page) {
          distanceThroughBook = BookUtils.getDistanceThroughBookWithPage(
            this.props.isbn,
            data.page
          );
        }
        if (distanceThroughBook !== undefined) {
          this.setState({
            showPage: true,
            pageUpdateTimeout: 800,
            distanceThroughBook: distanceThroughBook
          });
        } else {
          this.setState({
            showPage: true,
            pageUpdateTimeout: 800
          });
        }
        clearTimeout(this.pageUpdateTimeout);
        this.pageUpdateTimeout = setTimeout(() => {
          this.setState({ pageUpdateTimeout: 0 });
        }, 2000);
      } else {
        Dispatcher.bindOnce(Dispatcher.BOOK_PAGEBREAKS_LOADED, () => {
          this._pageLoad(isbn, e, data);
        });
      }
    } else {
      const toc = BookStore.get(this.props.isbn).getTOC();
      if (toc) {
        distanceThroughBook = BookUtils.getDistanceThroughBook(
          this.props.isbn,
          book.pageCFI + "!" + data.cfi
        );
        if (distanceThroughBook !== undefined) {
          this.setState({
            showPage: false,
            distanceThroughBook: distanceThroughBook
          });
        }
      } else {
        Dispatcher.bindOnce(Dispatcher.BOOK_TOC_LOADED, () => {
          this._pageLoad(isbn, e, data);
        });
      }
    }
  }

  _pageBreak(isbn, e, current_page) {
    if (current_page) {
      this.pageBreakTimeout = Fraction.Helpers.delayTimeout(
        function() {
          this.setState({
            defaultPageNumber: current_page,
            pageNumber: current_page,
            showPage: true
          });
        }.bind(this),
        this.state.pageUpdateTimeout,
        "scrubber-page-number-timeout"
      );
    }
  }

  _pageScroll(isbn, e, data) {
    const book = BookStore.get(this.props.isbn);

    // TODO why is this in here? why would I say that line below?
    // Maybe remove this when things get fixed

    // Save full CFI to use elsewhere
    this.setState({ fullCFI: book.pageCFI + "!" + data.cfi });

    if (book.hasPageBreaks && !book.getPageBreaks()) {
      Dispatcher.bindOnce(Dispatcher.BOOK_PAGEBREAKS_LOADED, () => {
        this._pageScroll(isbn, e, data);
      });
    }
    if (data.cfi) {
      var pagebreak = BookUtils.getPageBreakForCFI(
        book.isbn,
        book.pageCFI + "!" + data.cfi
      );
      if (pagebreak) {
        Fraction.Helpers.delayTimeout(
          function() {
            if (this._isMounted) {
              this.setState({
                defaultPageNumber: pagebreak.label,
                pageNumber: pagebreak.label,
                showPage: true
              });
            }
          }.bind(this),
          this.state.pageUpdateTimeout,
          "scrubber-page-number-timeout"
        );
      }
      this.setState({
        distanceThroughBook: BookUtils.getDistanceThroughBook(
          book.isbn,
          book.pageCFI + "!" + data.cfi
        )
      });
    }
  }

  setPageAndDefaultPage(page) {
    this.setState({ defaultPageNumber: page, pageNumber: page });
  }

  _goToPageBlur() {
    if (this.state.defaultPageNumber) {
      this.setState({ pageNumber: this.state.defaultPageNumber });
    }
  }

  _goToPageChange(value) {
    this.setState({ pageNumber: value.currentTarget.value });
  }

  _goToPageMobile() {
    _showMobileGoToPage(
      this.props.isbn,
      function(page) {
        this.setState({ pageNumber: page });
      }.bind(this)
    );
  }

  _showScrubberOptionMenu(e) {
    this._removeTooltipEvent(e);
    this._toggleMenu(e);
  }

  _showBookmarkMenu(e) {
    this._removeTooltipEvent(e);
    this._toggleMenu(e);
  }

  _bookmarksChanged(isbn) {
    this.setState({ addingBookmark: false });
  }

  _addBookmark(e) {
    this.setState({ addingBookmark: true }, () =>
      Fraction.Helpers.throttle(
        () => {
          BookmarkAction.addBookmark(this.props.isbn);
        },
        15,
        1000,
        "bookmarkAdd"
      )
    );
  }

  _bookmarkDeleteClicked(e) {}

  _citeButtonEvent() {
    Fraction.Helpers.copyEnabled();
    const book = BookStore.get(this.props.isbn);
    Dispatcher.emit(Dispatcher.OPEN_MODAL, "citations", { book });
    Fraction.Reporter.gaEvent("reader/options/citation");
  }

  _ttsEvent() {
    Fraction.Reporter.gaEvent("reader/options/tts");
  }

  // Link to page
  _linkButtonEvent(e) {
    const book = BookStore.get(this.props.isbn);
    book.viewer.Book.getUniversalURL(function(response) {
      var link;
      if (response.isSuccess()) {
        link =
          document.location.protocol +
          "//" +
          document.location.host +
          "/#" +
          response.data.url +
          document.location.search;
      } else {
        link =
          document.location.protocol +
          "//" +
          document.location.host +
          "/#/" +
          Fraction.Router.getRoute().join("/") +
          document.location.search;
      }
      Fraction.Helpers.Reader.copyURL(link);
    });
  }

  _addScrubberMenuTooltip(e) {
    if (!this.menuVisible) {
      this._addTooltipEvent(e);
    }
  }

  _addScrubberViewTooltip(e) {
    if (!this.menuVisible) {
      this._addTooltipEvent(e);
    }
  }

  _scrubberMove(distance) {
    const book = BookStore.get(this.props.isbn);
    if (!this.state.draggingScrubber) {
      const toc = BookStore.get(this.props.isbn).getTOC();
      if (toc) {
        this.setState({ draggingScrubber: true });
      }
    }
    distance = Math.min(99.99, Math.max(distance, 0));
    var chapterTitle = "";
    var pageLabel = false;
    if (book.hasPages) {
      var pagebreak = BookUtils.getPageBreakForDistance(
        this.props.isbn,
        distance
      );
      if (pagebreak) {
        pageLabel = pagebreak.label;
        chapterTitle = BookUtils.getChapterTitleForCFI(
          this.props.isbn,
          pagebreak.cfi
        );
      }
    } else {
      var chapter = BookUtils.getTOCForDistance(this.props.isbn, distance);
      chapterTitle = chapter ? chapter.title : false;
    }
    this.setState({ pageNumber: pageLabel, chapterTitle: chapterTitle });
  }

  _scrubberEnd(distance) {
    const book = BookStore.get(this.props.isbn);
    distance = Math.min(99.99, Math.max(distance, 0));
    if (book.hasPages) {
      var pageBreak = BookUtils.getPageBreakForDistance(
        this.props.isbn,
        distance
      );
      if (pageBreak) {
        book.goTo({ cfi: pageBreak.cfi });
        Fraction.Reporter.gaEvent(
          "reader/navigation/scrubber",
          "cfi: " + pageBreak.cfi
        );
      }
    } else {
      var toc = BookUtils.getTOCForDistance(this.props.isbn, distance);
      if (toc) {
        book.goTo({ cfi: toc.cfi });
        Fraction.Reporter.gaEvent(
          "reader/navigation/scrubber",
          "cfi: " + toc.cfi
        );
      }
    }
    this.setState({ draggingScrubber: false });
  }

  _goToPreviousPage(e) {
    const book = BookStore.get(this.props.isbn);
    if (book.viewer && this.state.hasPrevPage) {
      book.viewer.Book.goToPreviousPage(function() {});
    }
  }

  _goToNextPage(e) {
    const book = BookStore.get(this.props.isbn);
    if (book.viewer && this.state.hasNextPage) {
      book.viewer.Book.goToNextPage(function() {});
    }
  }

  _takeSurvey() {
    Fraction.Reporter.generalFeedback(true);
  }

  renderButtonTemplate(id, title, onClick) {
    return (
      <button
        key={"scrubber-visible-button-" + id}
        id={id}
        onClick={onClick}
        onTouchEnd={onClick}
        className="scrubber-button noButton"
        data-tooltip={title}
        data-tooltip-location="top"
        onMouseEnter={this._addTooltipEvent}
        onMouseLeave={this._removeTooltipEvent}
      >
        <Isvg src={"/img/" + id.slice(0, -7).replace(/-/g, "_") + "_icon.svg"}>
          NS
        </Isvg>
        <span className="offScreen">{title}</span>
      </button>
    );
  }

  turnTtsBarOn() {
    if (!this.state.ttsOn) {
      this.setState({ ttsOn: true });
    }
  }

  toggleTTS() {
    if (this.state.ttsOn) {
      Dispatcher.emit(Dispatcher.TTS_CLOSE);
    }
    this.setState({ ttsOn: !this.state.ttsOn });
    Fraction.Helpers.Users.saveUserData("seenTtsInfo", true);
  }

  renderSpeechIcon() {
    const ttsEnabled = Fraction.Brand.TTS.enabled;
    // Better to use TTS API for supported, but is async and this component is too complex already
    const ttsSupported = window.hasOwnProperty("speechSynthesis");
    const speakerColor = this.state.ttsOn
      ? colors[Fraction.Brand.Theme.secondary].getShade(5)
      : colors["cloud"].getShade(9);
    const seenTtsInfo =
      Fraction.Helpers.Users.getUserData("seenTtsInfo") || false;
    if (ttsEnabled) {
      const speakerButton = (
        <button
          id="speaker-button"
          key="speaker-button-tts"
          className="scrubber-button-custom noButton"
          onClick={this.toggleTTS}
          disabled={!ttsSupported}
          data-tooltip={i18n.t("reader.buttons.tts")}
          data-tooltip-location="top"
          onMouseEnter={this._addTooltipEvent}
          onMouseLeave={this._removeTooltipEvent}
        >
          <Speaker fill={speakerColor} />
          <span className="offScreen">{i18n.t("reader.buttons.tts")}</span>
        </button>
      );
      let toolTipString;
      let toolTipClick;

      if (!ttsSupported) {
        toolTipString = i18n.t("tts.browser-support");
      } else if (!seenTtsInfo) {
        toolTipString = i18n.t("tts.try-tts");
        toolTipClick = () => {
          Fraction.Helpers.Users.saveUserData("seenTtsInfo", true);
        };
      }
      return (
        <ScrubberToolTip
          key="tts-tooltip"
          text={toolTipString}
          seen={seenTtsInfo}
          icon={speakerButton}
          onClick={toolTipClick}
        />
      );
    }
  }

  _buildButtons() {
    const book = BookStore.get(this.props.isbn);
    const buttonList = [];
    const isMobile = Fraction.Helpers.isSmallScreen();
    if (
      Fraction.Brand.Scrubber.Buttons.print &&
      book.hasPageBreaks &&
      book.printLimit !== 0
    ) {
      buttonList.push(
        <PrintRangeToggleMenu
          id="print-button"
          key="scrubber-visible-button-print-range-button"
          isbn={this.props.isbn}
          currentPage={this.state.pageNumber}
          renderDisabledButton={label =>
            this.renderButtonTemplate("print-opacity-button", label)
          }
        />
      );
    } else {
      buttonList.push(
        this.renderButtonTemplate(
          "print-opacity-button",
          i18n.t("reader.buttons.print-unavailable")
        )
      );
    }

    if (!isMobile) {
      if (
        book.vbkType === "epub" &&
        book.layout !== "fixed" &&
        Fraction.Brand.ContentControls.enabled
      ) {
        buttonList.push(
          <EnhancedFormatting
            id="ehanced-formatting-button"
            key="scrubber-visible-button-ehanced-formatting-button"
            isbn={this.props.isbn}
            onClick={this._showScrubberOptionMenu}
            tooltip={i18n.t("enhanced-formatting.enhanced-formatting")}
          />
        );
      } else {
        buttonList.push(
          <ZoomButton
            id="aa-button"
            key="scrubber-visible-button-aa-button"
            className="scrubber-button noButton"
            tooltip={i18n.t("reader.buttons.resize-text")}
            onClick={this._showScrubberOptionMenu}
            onMouseEnter={this._addScrubberMenuTooltip}
            onMouseLeave={this._removeTooltipEvent}
            aria-expanded="false"
            isbn={this.props.isbn}
          />
        );
      }

      const ttsBtn = this.renderSpeechIcon();
      if (ttsBtn) {
        buttonList.push(ttsBtn);
      }
    }
    if (
      Fraction.Brand.Reader.highlighting &&
      Fraction.Brand.Scrubber.Buttons.fast_highlighting &&
      !Fraction.Helpers.isTouchDevice() &&
      !isMobile
    ) {
      buttonList.push(
        <div
          className="reader-fast-highlight-container"
          key="scrubber-visible-button-fast-highlight-container"
        >
          <button
            id="fast-highlight-button"
            className="scrubber-button noButton"
            data-tooltip={i18n.t("reader.buttons.fast-highlighting")}
            data-tooltip-location="top"
            data-menu-id="scrubber-highlight-menu"
            onClick={this._showScrubberOptionMenu}
            onMouseEnter={this._addScrubberMenuTooltip}
            onMouseLeave={this._removeTooltipEvent}
            aria-expanded="false"
          >
            <Isvg src={"/img/fast_highlighter_icon.svg"}>NS</Isvg>
            <ColorBar
              fastHighlighting={this.props.fastHighlighting}
              highlightColor={MarkerStore.getCurrentMarker().color}
            />
            <span className="offScreen">
              {i18n.t("reader.buttons.fast-highlighting")}
            </span>
          </button>
          <Menu
            key="scrubber-highlight-menu"
            menuId="scrubber-highlight-menu"
            direction="down"
            yOffset={14}
          >
            <MenuHeader key="menu-header-reader.buttons.highlighting-mode">
              {i18n.t("reader.buttons.fast-highlighting-header")}
            </MenuHeader>
            <HighlighterColors
              fast={true}
              fastHighlighting={this.props.fastHighlighting}
              onFastClick={bool => {
                this.props.fastHighlightClick(bool);
                this._removeMenu();
              }}
            />
          </Menu>
        </div>
      );
    }
    if (Fraction.Brand.Citations.enabled) {
      buttonList.push(
        this.renderButtonTemplate(
          "citation-button",
          i18n.t("reader.buttons.cite"),
          this._citeButtonEvent
        )
      );
    }

    if (Fraction.Brand.Scrubber.Buttons.link) {
      buttonList.push(
        this.renderButtonTemplate(
          "link-page-button",
          i18n.t("reader.buttons.link"),
          this._linkButtonEvent
        )
      );
    }

    let buttonsToShow = 5;
    buttonsToShow = Math.max(
      2,
      Math.floor(
        (this.props.windowWidth -
          520 -
          ($("#go-to-page").outerWidth(true) || 0)) /
          58
      )
    );
    // TODO buttons to show should be all now - scrubber resizes
    buttonsToShow = 6;
    if (isMobile) {
      buttonsToShow = 0;
    }
    const overflowButtons = buttonList.slice(buttonsToShow);
    return {
      visibleButtons: buttonList.slice(0, buttonsToShow),
      overflowMenu:
        overflowButtons.length > 0 ? (
          <MenuList
            key="scrubber-menu-list"
            items={overflowButtons.map(btn => {
              return {
                label: btn.props["data-tooltip"],
                clickEvent: btn.props.onClick
              };
            })}
          />
        ) : (
          false
        )
    };
  }

  renderBookMarkingButtons(isMobile) {
    if (!(this.state.showPage && Fraction.Brand.Reader.bookmarks)) {
      return null;
    }
    const scrubberBarHidden = this._getScrubberBarState();
    const bookmarks = BookmarkStore.getAll(this.props.isbn).bookmarks;
    let icon = (
      <Isvg id="bookmark-chevron" src={"/img/chevron_sm-up.svg"}>
        NS
      </Isvg>
    );
    let bookMarkIcon = <Isvg src="/img/bookmark_add.svg">NS</Isvg>;
    let bookMarkToggled;
    if (bookmarks) {
      for (var i = 0; i < bookmarks.length; i++) {
        bookMarkToggled = bookmarks[i].page === this.state.pageNumber;
        if (bookmarks[i].page === this.state.pageNumber) {
          bookMarkIcon = (
            <span id="bookmarked">
              <Isvg src="/img/bookmark_filled.svg">NS</Isvg>
            </span>
          );
        }
      }
    }

    if (this.state.addingBookmark) {
      icon = (
        <div className="small-loader">
          <Isvg src="/img/loader_small.svg">
            <img src={"/img/loader_small.png"} />
          </Isvg>
        </div>
      );
    }

    return (
      <div
        aria-hidden={isMobile ? scrubberBarHidden === "none" : null}
        style={isMobile ? { display: scrubberBarHidden } : null}
      >
        <button
          className={"bookmark-button noButton"}
          id={isMobile ? "mobile-bookmark-icon" : null}
          data-tooltip={i18n.t("bookmarks.add-bookmark")}
          data-tooltip-location="top"
          data-tooltip-min-left="44"
          onClick={this._addBookmark}
          onTouchEnd={this._addBookmark}
          onMouseEnter={this._addTooltipEvent}
          onMouseLeave={this._removeTooltipEvent}
          aria-pressed={bookMarkToggled ? "true" : "false"}
          disabled={bookMarkToggled}
        >
          {bookMarkIcon}
          <span className="hide-button">
            {i18n.t("bookmarks.add-bookmark")}
          </span>
        </button>
        <button
          className={
            "bookmark-menu-button noButton " +
            (this.state.addingBookmark ? " loading" : " arrow")
          }
          id={isMobile ? "mobile-bookmark-menu" : null}
          data-menu-id={
            isMobile ? "bookmark-menu-mobile" : "bookmark-menu-desktop"
          }
          onClick={this._showBookmarkMenu}
          onTouchEnd={this._showBookmarkMenu}
          data-tooltip={i18n.t("reader.panels.bookmarks")}
          data-tooltip-location="top"
          onMouseEnter={this._addTooltipEvent}
          onMouseLeave={this._removeTooltipEvent}
          aria-expanded="false"
        >
          {icon}
          <span className="hide-button">
            {i18n.t("reader.panels.bookmarks")}
          </span>
        </button>
      </div>
    );
  }

  _renderMobileScrubber(buttonObject, isMobile) {
    if (Fraction.Helpers.isSmallScreen()) {
      var mobileButtons = this.props.mobileButtons;
      return (
        <div
          aria-hidden={!Fraction.Helpers.isSmallScreen()}
          id="mobile-scrubber-container"
          role="region"
          aria-label={i18n.t("reader.book-tools")}
          className={"respond-mobile " + this.props.expanded}
        >
          {this.renderTtsToolbar()}
          <Scrubber
            buttonNumber={buttonObject.visibleButtons.length}
            mouseMoveEvent={this._scrubberMove}
            endDragEvent={this._scrubberEnd}
            progress={this.state.distanceThroughBook * 100.0}
          />
          <div className="mobile-menu-options">
            {this.renderBookMarkingButtons(isMobile)}
            <ZoomButton
              id="aa-button-mobile"
              className="scrubber-button noButton"
              tooltip={i18n.t("reader.buttons.resize-text")}
              onClick={this._showScrubberOptionMenu}
              onMouseEnter={this._addScrubberMenuTooltip}
              onMouseLeave={this._removeTooltipEvent}
              aria-expanded="false"
              isbn={this.props.isbn}
            />
            {this.state.showPage && (
              <BookmarksContainer
                ref={this.bookmarkRef}
                isbn={this.props.isbn}
                fullCFI={this.state.fullCFI}
                yOffset={3}
                menuID="bookmark-menu-mobile"
              />
            )}

            {buttonObject.overflowMenu && (
              <button
                id="more-button"
                className="scrubber-button noButton"
                data-menu-id="mobile-scrubber-options-menu"
                onClick={this._showScrubberOptionMenu}
                onTouchEnd={this._showScrubberOptionMenu}
                aria-expanded="false"
              >
                <span className="offScreen">
                  {i18n.t("reader.buttons.more-options")}
                </span>
              </button>
            )}
            <Menu
              key="mobile-scrubber-options-menu"
              menuId="mobile-scrubber-options-menu"
              direction="down"
              yOffset={0}
            >
              {buttonObject.overflowMenu}
            </Menu>
            {this.renderSpeechIcon()}
          </div>
          {this.state.showPage && (
            <button
              id="go-to-page-mobile"
              className="noButton"
              onClick={this._goToPageMobile}
            >
              {this.state.pageNumber}
            </button>
          )}
          <div className="scrubber-buttons">
            {mobileButtons.map(button => (
              <button
                key={"mobile-scrubber-button-" + button.id}
                className={`scrubber-button-container noButton${
                  button.light && button.light() ? " light" : ""
                }`}
                onClick={button.clickEvent}
              >
                <div id={button.id} className="scrubber-button" />
                <span>{button.title}</span>
              </button>
            ))}
          </div>
        </div>
      );
    }
  }

  renderTtsToolbar() {
    if (this.state.ttsOn) {
      const classes = ["tts-toolbar-container"];
      if (this._getScrubberBarState()) {
        classes.push("tts-scrubber-bar-hidden");
      }
      if (Fraction.Helpers.isSmallScreen()) {
        classes.push("tts-small-screen");
      }

      return (
        <div className={classes.join(" ")}>
          <div id="tts-toolbar">
            <ToolbarWithTts
              isbn={this.props.isbn}
              onClose={() => {
                this.setState({ ttsOn: false });
              }}
            />
          </div>
        </div>
      );
    }
    return null;
  }

  render() {
    const scrubberBarHidden = this._getScrubberBarState();
    const isMobile = Fraction.Helpers.isSmallScreen();
    const buttonObject = this._buildButtons();
    const bw = $("#book-wrapper");
    let bwRect = {};

    //feedback button // remove me! // no productions!
    if (this.state.draggingScrubber) {
      bwRect = { top: bw.offset().top, left: bw.offset().left };
      bwRect.bottom = $(window).height() - (bwRect.top + bw.outerHeight(true));
      bwRect.right = $(window).width() - (bwRect.left + bw.outerWidth(true));
    }

    if (isMobile) {
      return this._renderMobileScrubber(buttonObject, isMobile);
    }

    return (
      <div className={this.state.draggingScrubber ? "no-highlight" : ""}>
        {this.state.draggingScrubber && (
          <div className="scrubber-tooltip" style={bwRect}>
            <div className={bw.outerWidth(true) < 438 ? "small" : ""}>
              {this.state.chapterTitle && (
                <div className="scrubber-chapter-title">
                  {this.state.chapterTitle}
                </div>
              )}
              {this.state.pageNumber && (
                <div className="scrubber-page-number">
                  {this.state.pageNumber}
                </div>
              )}
            </div>
          </div>
        )}
        <h2 className="offScreen">{i18n.t("reader.book-toolbar")}</h2>
        <div
          aria-hidden={Fraction.Helpers.isSmallScreen()}
          id="scrubber-container"
          role="region"
          aria-label={i18n.t("reader.book-tools")}
          className={`respond-desktop ${this.props.expanded}`}
          ref={this.scrubberContainerRef}
        >
          {this.renderTtsToolbar()}
          <button
            aria-expanded={FractionStore.get()["scrubber-open"]}
            className={`scrubber-tab noButton ${
              this.state.ttsOn ? "hide-tab" : ""
            }`}
            onClick={this.props.toggleScrubberEvent}
          >
            <div aria-hidden="true" role="presentation" />
            <span className="offScreen">
              {i18n.t("reader.buttons.book-controls")}
            </span>
            <Isvg
              id={`scrubber-tab-${scrubberBarHidden === "" ? "down" : "up"}`}
              src={"/img/chevron_list.svg"}
            >
              NS
            </Isvg>
          </button>
          <div>
            {this.state.showPage && (
              <div
                aria-hidden={scrubberBarHidden === "none"}
                style={{ display: scrubberBarHidden }}
              >
                <PageNumberForm
                  isbn={this.props.isbn}
                  goToPageBlur={this._goToPageBlur}
                  goToPageChange={this._goToPageChange}
                  page={this.state.pageNumber}
                  setPageAndDefaultPage={this.setPageAndDefaultPage}
                  updatePageNumber={this.props.updatePageNumber}
                />
                {this.renderBookMarkingButtons(isMobile)}
                <BookmarksContainer
                  ref={this.bookmarkRef}
                  isbn={this.props.isbn}
                  fullCFI={this.state.fullCFI}
                  menuID="bookmark-menu-desktop"
                />
              </div>
            )}
            <Scrubber
              buttonNumber={buttonObject.visibleButtons.length}
              mouseMoveEvent={this._scrubberMove}
              endDragEvent={this._scrubberEnd}
              progress={this.state.distanceThroughBook * 100.0}
              pageNumber={this.state.pageNumber}
            />
            <div
              className="scrubber-buttons"
              ref={this.scrubberButtonsRef}
              aria-hidden={scrubberBarHidden === "none"}
              style={{ display: scrubberBarHidden }}
            >
              {buttonObject.visibleButtons}
              {buttonObject.overflowMenu && (
                <button
                  id="more-button"
                  className="scrubber-button noButton"
                  data-tooltip={i18n.t("reader.buttons.more-options")}
                  data-tooltip-location="top"
                  data-menu-id="scrubber-options-menu"
                  onClick={this._showScrubberOptionMenu}
                  onTouchEnd={this._showScrubberOptionMenu}
                  onMouseEnter={this._addScrubberMenuTooltip}
                  onMouseLeave={this._removeTooltipEvent}
                  aria-expanded={false}
                >
                  <Isvg src={"/img/dots.svg"}>NS</Isvg>
                  <span className="offScreen">
                    {i18n.t("reader.buttons.more-options")}
                  </span>
                </button>
              )}
              <Menu
                key="scrubber-options-menu"
                menuId="scrubber-options-menu"
                direction="down"
                yOffset={14}
              >
                <MenuHeader key="menu-header-reader.buttons.more-options">
                  {i18n.t("reader.buttons.more-options")}
                </MenuHeader>
                {buttonObject.overflowMenu}
              </Menu>
            </div>
          </div>
        </div>
        <Tooltip tooltip={this.state.tooltip} />
      </div>
    );
  }
}

module.exports = ScrubberContainer;
